export default __webpack_public_path__ + "static/media/google-register-2-en.acc7e953.png";